import { fetchFlightLocationSuggestion } from "@b2bportal/core-flights";
import { fetchPlace } from "@b2bportal/core-hotels";
import { HotelNavigationUtility, logger } from "@overrides/utilities";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { PackageSearchQueryParams } from "../../../../utilities";
import { fetchPackageHotelAvailability } from "../../../hotels/store/thunks";
import { initialSearchState } from "../../../search/store";
import type { PackageSearchState } from "../slice";

export const initializePackages = createAsyncThunk<
  PackageSearchState,
  { search: PackageSearchQueryParams }
>("packages/initialize", async ({ search }, thunkAPI) => {
  try {
    const [origin, destination] = await Promise.all([
      fetchFlightLocationSuggestion(search.origin),
      fetchPlace(HotelNavigationUtility.urlToPlaceQuery(search.destination)),
    ]);

    if (!origin || !destination) {
      return thunkAPI.rejectWithValue("Error fetching locations");
    }

    const requestedSearch = {
      dateRange: {
        from: search.fromDate,
        until: search.untilDate,
      },
      guests: {
        adultCount:
          search.adults ??
          initialSearchState.searchFormValues.guests.adultCount,
        childAges: search.children ?? [],
        infantOnLapAges: [],
        infantInSeatAges: [],
      },
      roomCount: search.roomCount,
      origin,
      destination,
    };

    thunkAPI.dispatch(
      fetchPackageHotelAvailability({ search: requestedSearch })
    );

    //TODO: Also populate hotel and flight search state.

    return {
      searchFormValues: requestedSearch,
      requestedSearch,
    };
  } catch (error) {
    // Log and reject with detailed error message
    logger.debug(`Error fetching search locations. ${error}`);
    const errorMessage = error instanceof Error ? error.message : String(error);
    return thunkAPI.rejectWithValue(errorMessage);
  }
});
